"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperDrawerHeader = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_dom_1 = require("react-dom");
const BeamContext_1 = require("../../BeamContext");
const ButtonGroup_1 = require("../../ButtonGroup");
const Css_1 = require("../../../Css");
const utils_1 = require("../../../utils");
function SuperDrawerHeader(props) {
    var _a, _b;
    const { hideControls } = props;
    const { sdHeaderDiv, drawerContentStack: contentStack } = (0, BeamContext_1.useBeamContext)();
    const firstContent = (_a = contentStack.current[0]) === null || _a === void 0 ? void 0 : _a.opts;
    const { onPrevClick, onNextClick } = firstContent !== null && firstContent !== void 0 ? firstContent : {};
    const currentContent = (_b = contentStack.current[contentStack.current.length - 1]) === null || _b === void 0 ? void 0 : _b.opts;
    const isDetail = currentContent !== firstContent;
    const tid = (0, utils_1.useTestIds)({}, "superDrawerHeader");
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.aic.jcsb.gap3.$, ...tid, children: [isStructuredProps(props) ? ((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.jcsb.aic.gap2.fg1.$, children: [(0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.fg1.df.aic.gap2.$, children: [(0, jsx_runtime_1.jsx)("h1", { children: props.title }), props.left] }), props.right && (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.fs0.$, children: props.right })] })) : ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.fg1.$, children: props.children })), !hideControls && ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.fs0.if(isDetail).invisible.$, children: (0, jsx_runtime_1.jsx)(ButtonGroup_1.ButtonGroup, { buttons: [
                        { icon: "chevronLeft", onClick: () => onPrevClick && onPrevClick(), disabled: !onPrevClick },
                        { icon: "chevronRight", onClick: () => onNextClick && onNextClick(), disabled: !onNextClick },
                    ], ...tid.actions }) }))] }), sdHeaderDiv);
}
exports.SuperDrawerHeader = SuperDrawerHeader;
function isStructuredProps(props) {
    return typeof props === "object" && "title" in props;
}
